import React from "react"
import styled, { ThemeProvider } from "styled-components"
import posed, { PoseGroup } from "react-pose"
import theme, { colors, responsive } from "buoy-theme"
import LoadingScreen from "buoy-loading-screen"
import CommonContainer from "../../common/components/Container"
import ProfileSwitcher from "../../common/components/ProfileSwitcher"
import PlanDetails from "../../common/components/PlanDetails"
import HeroCard from "./HeroCard"
import Recommendations from "./Recommendations"
import Footer from "./Footer"
import Welcome from "./Welcome"


const LoadingFade = posed.div({
  enter: {
    opacity: 1,
    transition: { duration: 200 }
  },
  exit: {
    opacity: 0,
    transition: { duration: 400, ease: "easeInOut" }
  }
})

const DashboardFade = posed.div({
  enter: {
    opacity: 1,
    delay: 500,
    transition: { duration: 400, ease: "easeInOut" }
  },
  exit: {
    opacity: 0,
    transition: { duration: 200 }
  }
})

const Container = styled(CommonContainer)`
  background: ${colors.neutralLightest};
  min-height: 100vh;
  padding: 0 100px;
  ${responsive("padding", "0 100px", "0 100px", "0 50px", "0 50px", "0 20px")};
`

const Content = styled.div`
  margin: 0 auto;
  ${responsive("padding-top", "200px", "200px", "120px", "120px", "120px")};
  ${responsive("padding-bottom", "110px", "110px", "80px", "80px", "80px")};
  display: flex;
  ${responsive("flex-direction", "row", "row", "column", "column", "column")};
  ${responsive("max-width", "1200px", "1200px", "688px", "688px", "none")};
`

const MainContent = styled.div`
  height: 100%;
  width: 100%;
  ${responsive("padding-right", "125px", "75px", "0", "0", "0")};
  flex: 1;
  order: 1;
`

const SideContent = styled.div`
  height: auto;
  min-height: 100%;
  width: 100%;
  ${responsive("order", "4", "4", "2", "2", "2")};
  ${responsive("flex-basis", "365px", "365px", "unset", "unset", "unset")};
  ${responsive("display", "initial", "initial", "none", "none", "none")};
`

const MobileContent = styled.div`
  width: 100%;
  ${responsive("display", "none", "none", "flex", "flex", "flex")};
  flex-direction: column;
`

const Dashboard = ({
  profile,
  profiles,
  goToProfile,
  recommendations,
  loggedIn,
  signedUp,
  planInformation,
  loaded
}) => (
  <ThemeProvider theme={theme}>
    <PoseGroup>
      {loaded ? (
        <DashboardFade key="dashboard-fade">
          <Container>
            <Content>
              <MainContent>
                <Welcome
                  profile={profiles.length === 0 ? loggedIn === "ok" : profile}
                />
                {loggedIn === "ok" &&
                  !signedUp &&
                  !planInformation && <PlanDetails dashboard />}
                <HeroCard />
                <MobileContent>
                  <ProfileSwitcher
                    dashboard
                    loggedIn={loggedIn}
                    signedUp={signedUp}
                    selectedProfile={profile}
                    profiles={profiles}
                    goToProfile={goToProfile}
                    showPrivacy
                  />
                </MobileContent>
                {recommendations && (
                  <Recommendations recommendations={recommendations} />
                )}
              </MainContent>
              <SideContent>
                <ProfileSwitcher
                  dashboard
                  loggedIn={loggedIn}
                  signedUp={signedUp}
                  selectedProfile={profile}
                  profiles={profiles}
                  goToProfile={goToProfile}
                  showPrivacy
                />
              </SideContent>
            </Content>
            <Footer />
          </Container>
        </DashboardFade>
      ) : (
        <LoadingFade key="loading-fade">
          <LoadingScreen/>
        </LoadingFade>
      )}
    </PoseGroup>
  </ThemeProvider>
)

export default Dashboard



// WEBPACK FOOTER //
// ./assets/dashboard/components/Dashboard.js